<template>
  <div
    class="flex flex-col sm:flex-wrap md:flex-row gap-3 bg-opacity-90 bg-untitled-gray-50"
  >
    <div
      class="flex justify-center items-center bg-brand/20 p-2 border border-brand/35 md:shadow-lg rounded-md cursor-pointer drop-shadow-sm gap-2"
      @click="handleClickTab('featured')"
      v-if="selectedMainTab !== 'featured' && showFeaturedTab"
    >
      <el-tooltip
        :content="wrapTooltipContent('Show All Assignments')"
        effect="dark"
        :raw-content="true"
        placement="bottom"
      >
        <HomeIcon class="w-7 hidden md:block text-brand" />
      </el-tooltip>
      <p
        class="text-xs font-semibold uppercase text-center md:hidden text-brand"
      >
        Assignments
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('enrolled')"
      :class="[
        {
          'bg-brand text-white hover:text-white': selectedMainTab === 'enrolled',
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedMainTab !== 'enrolled',
        },
      ]"
    >
      <p
        class="text-xs font-semibold uppercase text-center"
      >
        {{ tabName }}
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('playlist')"
      :class="[
        {
          'bg-brand text-white hover:text-white': selectedMainTab === 'playlist',
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedMainTab !== 'playlist',
        },
      ]"
    >
      <p
        class="text-xs font-semibold uppercase text-center"
      >
        {{ userName }} Learning Path & Playlists
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('content')"
      :class="[
        {
          'bg-brand text-white hover:text-white': selectedMainTab === 'content',
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedMainTab !== 'content',
        },
      ]"
    >
      <p
        class="text-xs font-semibold uppercase text-center"
      >
        All Available Content
      </p>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ElTooltip } from "element-plus";
import { useAuthStore } from "@/stores";
import { computed, defineProps } from "vue";
import { HomeIcon } from "@heroicons/vue/solid";
import { wrapTooltipContent } from "@/composable/wrapTooltipContent";
import { useLayout2HomeTabsStore } from "@/modules/Layout2/stores/useLayout2HomeTabs.store";
import { useLayout2CoursesStore } from "@/modules/Layout2/stores/useLayout2Courses.store";

const props = defineProps({
  showFeaturedTab: {
    type: Boolean,
    default: false,
  }
})

const authStore = useAuthStore();
const layout2HomeTabsStore = useLayout2HomeTabsStore();
const homeCoursesStore = useLayout2CoursesStore();
const { selectedMainTab } = storeToRefs(layout2HomeTabsStore);

const userName = computed(() => authStore.fullName);
const tabName = computed(() => homeCoursesStore.homeTab);
const showFeaturedTab = computed(() => props.showFeaturedTab);

const handleClickTab = (tab) => {
  selectedMainTab.value = tab;
};
</script>

<style scoped></style>
